<app-dyn-task #dynTask [key]="key" [isEditable]="true" [showTitle]="true" [data]="data">
</app-dyn-task>

<div class="controls">
    <button mat-button (click)="submitTaskFormResponse()">Complete</button>
</div>